const Actions = {
  SELECT_FILE: 'v.reports-of-sickness-import-new.actions.select-file',
  NAVIGATE: 'v.reports-of-sickness-import-new.actions.navigate',
  UPDATE_COMPLETED: 'v.reports-of-sickness-import-new.actions.update-completed',
  CANCEL: 'v.reports-of-sickness-import-new.actions.cancel'
};

const Mutations = {
  CLEAR: 'v.reports-of-sickness-import-new.mutations.clear',
  SET_FILE: 'v.reports-of-sickness-import-new.mutations.set-file',
  SET_ACTIVE_VIEW: 'v.reports-of-sickness-import-new.mutations.set-active-view',
  SET_COMPLETED: 'v.reports-of-sickness-import-new.mutations.set-completed'
};

const Views = {
  ImportFile: 'v.reports-of-sickness-import-new.import-file',
  ImportReport: 'v.reports-of-sickness-import-new.import-report'
};

export default {
  Actions,
  Mutations,
  Views
};
